export const PolicySourceEpic = 1;
export const PolicySourceManual = 2;
export const PolicySourceAOR = 3;
export const PolicySourceControlling = 4;
export const PolicySourceParticipant = 5;
export const PolicySourceMultiCarrierSchedules = 6;

// Represents types in the PolicySource table
export const PolicySource = {
  PolicySourceEpic,
  PolicySourceManual,
  PolicySourceAOR,
  PolicySourceControlling,
  PolicySourceParticipant,
  PolicySourceMultiCarrierSchedules,
} as const;

export type PolicySourceType = typeof PolicySource[keyof typeof PolicySource];
